import { render } from "./CategoryName.vue?vue&type=template&id=38f5a504&ts=true"
import script from "./CategoryName.vue?vue&type=script&lang=ts"
export * from "./CategoryName.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__